import $ from 'jquery'

export default {
    name: 'assure-observations',
    components: {},
    props: {
        list_exclu_observations: Array
    },
    data() {
        return {
            all_checked: false,
            one_is_checked: [],
			each_cat_is_checked: [],
            text_grey: []
        }
    },

    watch: {
        one_is_checked() {
            this.$store.commit('SET_EXCLU_OBSERVATION', this.one_is_checked)
        }
    },

    computed: {
        tarif_observations() {
            return this.$store.getters["tarif_observations"];
        },
    },

    mounted() {
        this.listeObservations()
    },

    methods: {
        listeObservations() {
            const data = {
                assurance_id: 0,
                data_type: 'observation'
            }

            this.$store.dispatch('getTarificationTypeAdmission', data).then(() => {
                if (this.tarif_observations.length > 0) {
                    this.setSelectedObservations()
                } 
            })
        },

        setSelectedObservations() {
			this.one_is_checked = []
            this.text_grey = []

            this.list_exclu_observations.forEach(exclusion => {
                this.tarif_observations.forEach(observation => {
					if (exclusion.id == observation.id) {
                        this.text_grey[observation.id] = 'text-grey'
                        this.one_is_checked.push(observation.id)
                    } 
                });
            });
		},

        toutSelectionner() {
            let is_checked = $('#all-observation').is(":checked")
            this.toggleAllChecked(is_checked)
        },

        toggleAllChecked(is_checked) {
            this.one_is_checked = []
            this.each_cat_is_checked = []
            
            this.tarif_observations.forEach((observation) => {
                if (is_checked) {
                    this.one_is_checked.push(observation.id)
                }
                this.text_grey[observation.id] = (is_checked)?'text-grey':''
            });
            
            this.all_checked = is_checked
        },

        onExclu(index) {
            let is_checked = $('#observation'+index).is(":checked")

            let c = ''
            if (is_checked == true) {
                c = 'text-grey'
            }
            this.text_grey[index] = c
        },
    }
}